module.exports = __webpack_public_path__ + "img/settingsEight.3042f655.svg";